import React from 'react';
import StaticContent from 'components/StaticContent';
import withMainLayout from 'with/withMainLayout';

function WoaatncPage() {
  return <StaticContent src="/woaatnc" />;
}

export default withMainLayout(WoaatncPage);
